import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";
import cn from "classnames";

import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { NewLabel2 } from "../NewLabel2";

type PDPNameHeadlineProps = {
  headline: string;
  subheadline: string | undefined;
  isNew: boolean;
};

export const PDPNameHeadline: ReactTFC<React.PropsWithChildren<PDPNameHeadlineProps>> = ({
  headline,
  isNew,
  subheadline,
  children,
}) => {
  const subheadlineStyles = [
    FONTS.SwarovskiFutura500,
    fontColor.black,
    fontSize.x2,
    css`
      margin: 0 0 10px;
    `,
  ];

  const headlineStyles = [
    FONTS.SwarovskiFutura300,
    fontSize.x6,
    css`
      line-height: 1;
    `,
  ];

  return (
    <>
      {subheadline && (
        <h2 className="u-uppercase" css={subheadlineStyles}>
          {subheadline}
        </h2>
      )}

      <h1 className={cn("so-color-green u-mt-0", !!children ? "u-mb-0_5" : "u-mb-5")} css={headlineStyles}>
        <NewLabel2 name={headline} isNew={isNew} />
      </h1>

      {children && <div className="u-mb-4">{children}</div>}
    </>
  );
};
